import React from "react";
import {useParams } from "react-router-dom";
import BaseIndex from "../BaseIndex";

export default function MenuLayout(props) {
  return (
    <BaseIndex {...props} category="menu"/>
  );
}
